
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28792",
  depVersions: {
  "payments-ui-app": "static-1.28792",
  "bend-plugin-arboretum": "static-1.2055",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.512",
  "crm_data": "static-4.93279",
  "data-fetching-client": "static-1.10146",
  "emoji-mart": "static-3.9",
  "enviro": "static-4.523",
  "foundations-components": "static-1.8800",
  "foundations-components-legacy": "static-1.1825",
  "head-dlb": "static-1.5330",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6097",
  "hs-test-utils": "static-1.8548",
  "hub-http": "static-1.6711",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11997",
  "I18n": "static-7.1717",
  "jasmine-runner": "static-1.6962",
  "quartz": "static-1.7699",
  "raven": "static-3.6411",
  "react-dlb": "static-1.96",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.123",
  "react-utils": "static-2.5683",
  "reselect": "static-3.18",
  "stripe-js": "static-1.122",
  "ui-components-test-utils": "static-1.6134",
  "UIComponents": "static-3.8943",
  "usage-tracker-public": "static-1.7638",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38110",
  "payments-checkout-lib": "static-1.715",
  "cssUtils": "static-1.1131",
  "customer-data-objects": "static-1.8220",
  "FireAlarmUi": "static-1.4895",
  "foundations-assets": "static-1.5396",
  "foundations-theming": "static-1.5000",
  "graphql": "static-1.95",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12304",
  "icons": "static-2.710",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3389",
  "property-translator": "static-1.5886",
  "quartz-config": "static-1.1477",
  "quartz-core": "static-1.6918",
  "quartz-i18n": "static-1.1374",
  "quartz-routing": "static-1.1129",
  "quartz-tracking": "static-1.1078",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17244",
  "react-select-plus": "static-1.120",
  "react-virtualized": "static-2.114",
  "redux": "static-4.81",
  "redux-thunk": "static-2.86",
  "redux-toolkit": "static-1.84",
  "ReduxMessenger": "static-2.10879",
  "rpc-client-utils": "static-1.5171",
  "sanitize-text": "static-1.8667",
  "SharedI18nStrings": "static-1.190",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.520",
  "superstore": "static-1.5263",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11654",
  "ui-images": "static-2.1285",
  "usage-tracker-core": "static-1.7677",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3976",
  "quartz-webpack": "static-1.3923",
  "bend-plugin-quartz-routing": "static-1.777",
  "bender-build-tools": "static-1.3622",
  "crm_universal": "static-1.22771",
  "customer-data-email": "static-1.18691",
  "customer-data-ui-utilities": "static-1.10341",
  "dispatcher": "static-1.150",
  "frontend-preferences-client": "static-1.8428",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8267",
  "quick-fetch": "static-1.4248",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5069",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2716",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9937",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.113",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3178",
  "ui-fonts": "static-1.1259",
  "HeadJS": "static-2.830",
  "hs-test-utils-bend-plugin": "static-1.3659",
  "msw": "static-1.105",
  "msw-config": "static-1.36",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.420",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4811",
  "foundations-components-test-utils": "static-1.6283",
  "ui-addon-draggable": "static-3.5260",
  "commerce-billing-lib": "static-1.20549",
  "commerce-shared-components-lib": "static-1.19635",
  "commerce-tools-ui-lib": "static-1.11385",
  "crm-message-bus": "static-1.44173",
  "customer-data-objects-ui-components": "static-1.13541",
  "customer-data-properties": "static-1.53167",
  "growth-payments-core": "static-1.26561",
  "ui-addon-iframeable": "static-1.9586",
  "usage-tracker": "static-1.7827",
  "usage-tracker-container": "static-1.7817",
  "sassPrefix": "static-1.392",
  "inbound-db-properties-service-client": "static-1.4169",
  "foundations-theming-base": "static-1.3985",
  "bend-plugin-foundations-theming": "static-1.3483",
  "stylex": "static-1.48",
  "opentelemetry-fe-types": "static-1.301",
  "hub-http-janus": "static-1.914",
  "hubspotter-http": "static-1.4992",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.676",
  "quartz-auth": "static-1.1374",
  "quartz-head": "static-1.1364",
  "quartz-test": "static-1.1374",
  "trellis-components": "static-1.3197",
  "usage-tracker-session-replay": "static-1.5513",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.208",
  "web-vitals": "static-1.21",
  "immer": "static-1.107",
  "bend-plugin-chirp-manifest": "static-1.581",
  "chirp-fetch": "static-1.2410",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4975",
  "FormUrlGenerator": "static-2.5220",
  "sequences-lib": "static-1.8830",
  "apollo-link-hub-http": "static-2.5098",
  "FileManagerCore": "static-1.40390",
  "FileManagerLib": "static-1.40531",
  "hubspot-apollo-client": "static-1.5388",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.765",
  "timezone-utils": "static-2.5735",
  "ui-gdpr-components": "static-1.10658",
  "react-dnd-compat": "static-1.5113",
  "stylex-utils": "static-1.184",
  "trellis-theming": "static-1.1529",
  "react-flip-move": "static-1.85",
  "avatar-components": "static-1.2996",
  "hs-resources": "static-1.695",
  "pulse": "static-1.1162",
  "utility-belt": "static-1.3043",
  "zustand": "static-1.91",
  "batch-promise": "static-1.2059",
  "customer-data-associations": "static-1.7847",
  "customer-data-property-utils": "static-1.8562",
  "customer-data-tracking": "static-1.7377",
  "framework-data-table": "static-2.12890",
  "object-builder-ui-client": "static-1.50121",
  "payments-enrollment-embed-lib": "static-1.24314",
  "stripe-embedded-components": "static-1.8295",
  "ui-addon-opt": "static-4.8930",
  "ai-components-ui-library": "static-1.10077",
  "customer-data-rte": "static-1.33956",
  "cv-backend-services": "static-1.1612",
  "file-manager-components": "static-1.24891",
  "growth-onboarding-confetti": "static-1.3567",
  "growth-onboarding-empty-states": "static-1.6585",
  "hubspot-prosemirror": "static-1.19341",
  "InboxConnectUtils": "static-4.15899",
  "payment-link-components": "static-1.24523",
  "payments-post-enroll-local-storage-lib": "static-1.5611",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39224",
  "react-colorpicker": "static-2.10714",
  "ui-addon-upgrades": "static-9.18569",
  "ui-addon-video-player": "static-1.9128",
  "user-context": "static-1.5564",
  "restore-request-side-panel-lib": "static-1.2105",
  "atom": "static-1.5581",
  "reference-resolvers": "static-1.8693",
  "calling-global-api": "static-1.66312",
  "calling-internal-common": "static-1.31830",
  "calling-lifecycle-internal": "static-1.67694",
  "calling-lifecycle-messages": "static-1.59986",
  "commerce-products-lib": "static-1.10994",
  "conditional-properties-service-client": "static-1.4131",
  "crm-index-visualization-core": "static-1.4801",
  "crm-links": "static-1.6822",
  "crm-pipelines-api-client-types": "static-1.4461",
  "customer-data-properties-shared-msw-handlers": "static-1.10284",
  "data-agent-utils": "static-1.981",
  "data-token-picker": "static-1.17185",
  "external-options-client-types": "static-1.4456",
  "formula-editor": "static-1.15053",
  "google-libphonenumber": "static-1.52",
  "inbound-db-meta-service-client": "static-1.3792",
  "inbounddb-objects-service-types": "static-1.4532",
  "meetings-icalendar-utils-lib": "static-1.1141",
  "multi-currency-client-types": "static-1.4026",
  "pipeline-validation-client-types": "static-1.4301",
  "property-value-citations": "static-1.3781",
  "react-tinymce": "static-1.56328",
  "reference-resolvers-lite": "static-1.8620",
  "rich-text-lib": "static-1.20605",
  "smart-data-capture-core": "static-1.548",
  "tiered-pricing": "static-1.2337",
  "tinymce-config": "static-2.55454",
  "tinymce-plugins": "static-1.58568",
  "tinymce-themes": "static-1.57424",
  "topics-actions-lib": "static-1.694",
  "trellis-ext-i18n": "static-1.1434",
  "trial-components-library": "static-1.14438",
  "ui-addon-emoji-picker": "static-1.10372",
  "ui-addon-form-validation": "static-1.11352",
  "laboratory-lib": "static-3.7656",
  "onboarding-scopes": "static-1.6958",
  "seat-types-lib": "static-1.1105",
  "magpie-lib": "static-1.5934",
  "navigation-messaging": "static-1.8559",
  "ts-schema": "static-1.4412",
  "opentelemetry-web": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.10957",
  "hubspotter-http-shared-msw-handlers": "static-1.10955",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8687",
  "audio-components": "static-1.6615",
  "breeze-artifacts-sdk": "static-1.1094",
  "ContentUtils": "static-1.69551",
  "copilot-toolkit": "static-1.12212",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30108",
  "FileManagerImages": "static-1.38042",
  "html-to-image": "static-1.67",
  "immerable": "static-1.4648",
  "ui-universal-auth": "static-1.9806",
  "urlinator": "static-1.5023",
  "video-components": "static-1.14503",
  "video-data-lib": "static-1.36159",
  "video-embed": "static-1.36993",
  "hubspot-apollo-cache": "static-1.847",
  "trellis-migration-context": "static-1.87",
  "event-emitter": "static-1.1466",
  "fdsr-migration-layer": "static-1.522",
  "framework-builder-read-service-client": "static-1.4353",
  "bend-plugin-pulse": "static-1.665",
  "fast-json-patch": "static-1.76",
  "customer-data-reference-ui-components": "static-1.13680",
  "reporting-data": "static-1.69505",
  "tasks-actions-lib": "static-1.490",
  "purchase-motions-components": "static-1.6675",
  "growth-onboarding-feedback-components": "static-1.7090",
  "growth-onboarding-reliability": "static-1.5593",
  "marketplace-ui-apps-core": "static-1.19631",
  "onboarding-tours": "static-1.17439",
  "stripe-connect-js": "static-1.85",
  "chatspot-core": "static-1.24081",
  "content-assistance-lib": "static-1.8468",
  "draft-content-plugins": "static-1.29208",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22408",
  "breeze-engine-lib": "static-1.2284",
  "poll-commands": "static-1.3982",
  "video-components-external": "static-1.12501",
  "trellis-story-utils": "static-1.5004",
  "ui-addon-react-router-dom": "static-1.10034",
  "content-media-capture": "static-1.5845",
  "knowledge-content-types": "static-1.8767",
  "ui-business-units-lib": "static-1.9603",
  "ui-shepherd-react": "static-3.10791",
  "hub-http-contrib": "static-1.3537",
  "ui-addon-sales-email": "static-1.5712",
  "commerce-tours-lib": "static-1.6908",
  "getting-started-shared-tasks": "static-1.19621",
  "sales-checkout-service-client": "static-1.4031",
  "merchandise-lib": "static-1.288",
  "getting-started-shared-tasks-store": "static-1.18739",
  "onboarding-tours-utils": "static-1.1506",
  "calling-error-reporting": "static-1.31837",
  "shared-worker-versioning": "static-1.11549",
  "calling-usage-tracker": "static-1.7050",
  "conversations-skeleton-state": "static-1.7623",
  "voice-sms-access-library": "static-1.2554",
  "commerce-permissions": "static-1.1292",
  "products-iframe-lib": "static-1.8975",
  "products-ui-components-shared-msw-handlers": "static-1.11339",
  "crm-index-associations-lib": "static-1.6958",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11040",
  "sales-views-client-types": "static-1.4767",
  "framework-data-schema-resolvers": "static-1.7403",
  "location-customization-utils-lib": "static-1.10487",
  "data-agent-kit": "static-1.968",
  "enrichment-settings-lib": "static-1.327",
  "fsm": "static-1.4267",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7311",
  "bark-lib": "static-1.17040",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6404",
  "react-codemirror": "static-1.11149",
  "tinymce": "static-5.11",
  "interframe": "static-3.5248",
  "tinymce-data": "static-1.41539",
  "layout-dnd-components": "static-1.13275",
  "layout-dnd-utils": "static-1.12250",
  "ui-brand-identity-lib": "static-1.17022",
  "NamespacedHubStyle": "static-2.9385",
  "embedded-academy-lib": "static-1.16110",
  "hubs-service-types": "static-1.1772",
  "navigation-components": "static-1.19232",
  "nest": "static-1.743",
  "nudge-client-utils": "static-1.3470",
  "purchase-motions-api": "static-1.6678",
  "signup-constants": "static-1.20017",
  "idb-keyval": "static-1.57",
  "magpie-types": "static-1.5394",
  "reactive-lib": "static-1.1229",
  "simple-logging-lib": "static-1.3556",
  "nav-meta": "static-1.30869",
  "breeze-engine-core": "static-1.1562",
  "cms-field-types": "static-1.5320",
  "content-icons-ui": "static-1.2490",
  "integrations-lib": "static-1.17498",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.370",
  "unified-auth-core-lib": "static-1.1602",
  "social-insights-client-types": "static-1.22984",
  "outpost": "static-1.4639",
  "persist-promise": "static-1.4216",
  "reporting-client-types": "static-1.2868",
  "signup-ui-url-generator": "static-2.8543",
  "developer-experience-shared-components": "static-1.11050",
  "immutable-less": "static-1.5160",
  "marketplace-ui-client-types": "static-1.18506",
  "marketplace-ui-common": "static-1.21099",
  "ui-addon-integrations-directory-panel": "static-2.8459",
  "ui-extensibility-client-types": "static-1.4424",
  "growth-data-modal": "static-1.6177",
  "growth-onboarding-next-action-utils": "static-1.3042",
  "onboarding-tours-client": "static-1.5654",
  "ui-shepherd-tracker": "static-1.8172",
  "ui-coaching-tips": "static-1.29614",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1262",
  "highlight.js": "static-1.92",
  "content-media-composition-data-lib": "static-1.13649",
  "content-media-compositions": "static-2.17656",
  "media-bridge-lib": "static-1.19689",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4935",
  "calling-orchestration-schema": "static-1.37332",
  "framework-data-schema-quick-fetch": "static-1.7308",
  "crm-record-cards-service-types": "static-1.3879",
  "highcharts": "static-8.117",
  "storybook-react": "static-1.46",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16722",
  "browser-eslint": "static-2.57",
  "ContentData": "static-1.69626",
  "layout-data-lib": "static-1.10575",
  "academy-common-lib": "static-1.15571",
  "nudge-custom-function-registry": "static-1.3227",
  "nudge-renderer-utils": "static-1.3546",
  "whisper-core-api": "static-1.7685",
  "flux-actions": "static-1.383",
  "integrations-error-boundary-lib": "static-1.14913",
  "integrations-tracking-lib": "static-1.6133",
  "redux-observable": "static-1.81",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4116",
  "oauth-service-types": "static-1.4645",
  "ai-settings-ui-library": "static-1.8638",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1710",
  "onboarding-data-sync-lib": "static-1.2884",
  "growth-onboarding-next-action-components": "static-1.3070",
  "user-context-client": "static-1.5018",
  "js-cookie": "static-1.18",
  "advanced-menus-core": "static-1.15868",
  "advanced-menus-lib": "static-1.12608",
  "ExportDialog": "static-6.10881",
  "ui-memberships-settings-lib": "static-1.35267",
  "academy-service-client": "static-1.4201",
  "croppie": "static-2.10",
  "final-form": "static-1.85",
  "SafeStorage": "static-1.4904",
  "trellis-ecosystem": "static-1.7900",
  "wootric-nps": "static-1.7315",
  "universal-page-editor-lib": "static-1.3523",
  "settings-ui-lib": "static-1.13037",
  "simple-data-table": "static-1.3879",
  "meetings-connect-utils-lib": "static-1.8125",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15867",
  "simple-menus-lib": "static-1.17384",
  "crm-record-cards-client": "static-1.139"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28792",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2055",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.512",
  "crm_data": "/crm_data/static-4.93279",
  "data-fetching-client": "/data-fetching-client/static-1.10146",
  "emoji-mart": "/emoji-mart/static-3.9",
  "enviro": "/enviro/static-4.523",
  "foundations-components": "/foundations-components/static-1.8800",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1825",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6097",
  "hs-test-utils": "/hs-test-utils/static-1.8548",
  "hub-http": "/hub-http/static-1.6711",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11997",
  "I18n": "/I18n/static-7.1717",
  "jasmine-runner": "/jasmine-runner/static-1.6962",
  "quartz": "/quartz/static-1.7699",
  "raven": "/raven/static-3.6411",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.123",
  "react-utils": "/react-utils/static-2.5683",
  "reselect": "/reselect/static-3.18",
  "stripe-js": "/stripe-js/static-1.122",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6134",
  "UIComponents": "/UIComponents/static-3.8943",
  "usage-tracker-public": "/usage-tracker-public/static-1.7638",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38110",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.715",
  "cssUtils": "/cssUtils/static-1.1131",
  "customer-data-objects": "/customer-data-objects/static-1.8220",
  "FireAlarmUi": "/FireAlarmUi/static-1.4895",
  "foundations-assets": "/foundations-assets/static-1.5396",
  "foundations-theming": "/foundations-theming/static-1.5000",
  "graphql": "/graphql/static-1.95",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12304",
  "icons": "/icons/static-2.710",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3389",
  "property-translator": "/property-translator/static-1.5886",
  "quartz-config": "/quartz-config/static-1.1477",
  "quartz-core": "/quartz-core/static-1.6918",
  "quartz-i18n": "/quartz-i18n/static-1.1374",
  "quartz-routing": "/quartz-routing/static-1.1129",
  "quartz-tracking": "/quartz-tracking/static-1.1078",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17244",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-virtualized": "/react-virtualized/static-2.114",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.86",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "ReduxMessenger": "/ReduxMessenger/static-2.10879",
  "rpc-client-utils": "/rpc-client-utils/static-1.5171",
  "sanitize-text": "/sanitize-text/static-1.8667",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "superstore": "/superstore/static-1.5263",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11654",
  "ui-images": "/ui-images/static-2.1285",
  "usage-tracker-core": "/usage-tracker-core/static-1.7677",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3976",
  "quartz-webpack": "/quartz-webpack/static-1.3923",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.777",
  "bender-build-tools": "/bender-build-tools/static-1.3622",
  "crm_universal": "/crm_universal/static-1.22771",
  "customer-data-email": "/customer-data-email/static-1.18691",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10341",
  "dispatcher": "/dispatcher/static-1.150",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8428",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8267",
  "quick-fetch": "/quick-fetch/static-1.4248",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5069",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2716",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9937",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.113",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3178",
  "ui-fonts": "/ui-fonts/static-1.1259",
  "HeadJS": "/HeadJS/static-2.830",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3659",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.36",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.420",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4811",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6283",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5260",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20549",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19635",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11385",
  "crm-message-bus": "/crm-message-bus/static-1.44173",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13541",
  "customer-data-properties": "/customer-data-properties/static-1.53167",
  "growth-payments-core": "/growth-payments-core/static-1.26561",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9586",
  "usage-tracker": "/usage-tracker/static-1.7827",
  "usage-tracker-container": "/usage-tracker-container/static-1.7817",
  "sassPrefix": "/sassPrefix/static-1.392",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4169",
  "foundations-theming-base": "/foundations-theming-base/static-1.3985",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3483",
  "stylex": "/stylex/static-1.48",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.301",
  "hub-http-janus": "/hub-http-janus/static-1.914",
  "hubspotter-http": "/hubspotter-http/static-1.4992",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.676",
  "quartz-auth": "/quartz-auth/static-1.1374",
  "quartz-head": "/quartz-head/static-1.1364",
  "quartz-test": "/quartz-test/static-1.1374",
  "trellis-components": "/trellis-components/static-1.3197",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5513",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.208",
  "web-vitals": "/web-vitals/static-1.21",
  "immer": "/immer/static-1.107",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.581",
  "chirp-fetch": "/chirp-fetch/static-1.2410",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4975",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5220",
  "sequences-lib": "/sequences-lib/static-1.8830",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5098",
  "FileManagerCore": "/FileManagerCore/static-1.40390",
  "FileManagerLib": "/FileManagerLib/static-1.40531",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5388",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.765",
  "timezone-utils": "/timezone-utils/static-2.5735",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "react-dnd-compat": "/react-dnd-compat/static-1.5113",
  "stylex-utils": "/stylex-utils/static-1.184",
  "trellis-theming": "/trellis-theming/static-1.1529",
  "react-flip-move": "/react-flip-move/static-1.85",
  "avatar-components": "/avatar-components/static-1.2996",
  "hs-resources": "/hs-resources/static-1.695",
  "pulse": "/pulse/static-1.1162",
  "utility-belt": "/utility-belt/static-1.3043",
  "zustand": "/zustand/static-1.91",
  "batch-promise": "/batch-promise/static-1.2059",
  "customer-data-associations": "/customer-data-associations/static-1.7847",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8562",
  "customer-data-tracking": "/customer-data-tracking/static-1.7377",
  "framework-data-table": "/framework-data-table/static-2.12890",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50121",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24314",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8295",
  "ui-addon-opt": "/ui-addon-opt/static-4.8930",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10077",
  "customer-data-rte": "/customer-data-rte/static-1.33956",
  "cv-backend-services": "/cv-backend-services/static-1.1612",
  "file-manager-components": "/file-manager-components/static-1.24891",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3567",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6585",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19341",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15899",
  "payment-link-components": "/payment-link-components/static-1.24523",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5611",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39224",
  "react-colorpicker": "/react-colorpicker/static-2.10714",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18569",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9128",
  "user-context": "/user-context/static-1.5564",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2105",
  "atom": "/atom/static-1.5581",
  "reference-resolvers": "/reference-resolvers/static-1.8693",
  "calling-global-api": "/calling-global-api/static-1.66312",
  "calling-internal-common": "/calling-internal-common/static-1.31830",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67694",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59986",
  "commerce-products-lib": "/commerce-products-lib/static-1.10994",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4131",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4801",
  "crm-links": "/crm-links/static-1.6822",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4461",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10284",
  "data-agent-utils": "/data-agent-utils/static-1.981",
  "data-token-picker": "/data-token-picker/static-1.17185",
  "external-options-client-types": "/external-options-client-types/static-1.4456",
  "formula-editor": "/formula-editor/static-1.15053",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3792",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4532",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1141",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4026",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4301",
  "property-value-citations": "/property-value-citations/static-1.3781",
  "react-tinymce": "/react-tinymce/static-1.56328",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8620",
  "rich-text-lib": "/rich-text-lib/static-1.20605",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.548",
  "tiered-pricing": "/tiered-pricing/static-1.2337",
  "tinymce-config": "/tinymce-config/static-2.55454",
  "tinymce-plugins": "/tinymce-plugins/static-1.58568",
  "tinymce-themes": "/tinymce-themes/static-1.57424",
  "topics-actions-lib": "/topics-actions-lib/static-1.694",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1434",
  "trial-components-library": "/trial-components-library/static-1.14438",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10372",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "laboratory-lib": "/laboratory-lib/static-3.7656",
  "onboarding-scopes": "/onboarding-scopes/static-1.6958",
  "seat-types-lib": "/seat-types-lib/static-1.1105",
  "magpie-lib": "/magpie-lib/static-1.5934",
  "navigation-messaging": "/navigation-messaging/static-1.8559",
  "ts-schema": "/ts-schema/static-1.4412",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10957",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10955",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8687",
  "audio-components": "/audio-components/static-1.6615",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1094",
  "ContentUtils": "/ContentUtils/static-1.69551",
  "copilot-toolkit": "/copilot-toolkit/static-1.12212",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30108",
  "FileManagerImages": "/FileManagerImages/static-1.38042",
  "html-to-image": "/html-to-image/static-1.67",
  "immerable": "/immerable/static-1.4648",
  "ui-universal-auth": "/ui-universal-auth/static-1.9806",
  "urlinator": "/urlinator/static-1.5023",
  "video-components": "/video-components/static-1.14503",
  "video-data-lib": "/video-data-lib/static-1.36159",
  "video-embed": "/video-embed/static-1.36993",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.847",
  "trellis-migration-context": "/trellis-migration-context/static-1.87",
  "event-emitter": "/event-emitter/static-1.1466",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.522",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4353",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.665",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13680",
  "reporting-data": "/reporting-data/static-1.69505",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.490",
  "purchase-motions-components": "/purchase-motions-components/static-1.6675",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7090",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5593",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19631",
  "onboarding-tours": "/onboarding-tours/static-1.17439",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "chatspot-core": "/chatspot-core/static-1.24081",
  "content-assistance-lib": "/content-assistance-lib/static-1.8468",
  "draft-content-plugins": "/draft-content-plugins/static-1.29208",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22408",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2284",
  "poll-commands": "/poll-commands/static-1.3982",
  "video-components-external": "/video-components-external/static-1.12501",
  "trellis-story-utils": "/trellis-story-utils/static-1.5004",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10034",
  "content-media-capture": "/content-media-capture/static-1.5845",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9603",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10791",
  "hub-http-contrib": "/hub-http-contrib/static-1.3537",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5712",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6908",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19621",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4031",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18739",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1506",
  "calling-error-reporting": "/calling-error-reporting/static-1.31837",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11549",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7050",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7623",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2554",
  "commerce-permissions": "/commerce-permissions/static-1.1292",
  "products-iframe-lib": "/products-iframe-lib/static-1.8975",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11339",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6958",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11040",
  "sales-views-client-types": "/sales-views-client-types/static-1.4767",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7403",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10487",
  "data-agent-kit": "/data-agent-kit/static-1.968",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.327",
  "fsm": "/fsm/static-1.4267",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7311",
  "bark-lib": "/bark-lib/static-1.17040",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6404",
  "react-codemirror": "/react-codemirror/static-1.11149",
  "tinymce": "/tinymce/static-5.11",
  "interframe": "/interframe/static-3.5248",
  "tinymce-data": "/tinymce-data/static-1.41539",
  "layout-dnd-components": "/layout-dnd-components/static-1.13275",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12250",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17022",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9385",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16110",
  "hubs-service-types": "/hubs-service-types/static-1.1772",
  "navigation-components": "/navigation-components/static-1.19232",
  "nest": "/nest/static-1.743",
  "nudge-client-utils": "/nudge-client-utils/static-1.3470",
  "purchase-motions-api": "/purchase-motions-api/static-1.6678",
  "signup-constants": "/signup-constants/static-1.20017",
  "idb-keyval": "/idb-keyval/static-1.57",
  "magpie-types": "/magpie-types/static-1.5394",
  "reactive-lib": "/reactive-lib/static-1.1229",
  "simple-logging-lib": "/simple-logging-lib/static-1.3556",
  "nav-meta": "/nav-meta/static-1.30869",
  "breeze-engine-core": "/breeze-engine-core/static-1.1562",
  "cms-field-types": "/cms-field-types/static-1.5320",
  "content-icons-ui": "/content-icons-ui/static-1.2490",
  "integrations-lib": "/integrations-lib/static-1.17498",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.370",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1602",
  "social-insights-client-types": "/social-insights-client-types/static-1.22984",
  "outpost": "/outpost/static-1.4639",
  "persist-promise": "/persist-promise/static-1.4216",
  "reporting-client-types": "/reporting-client-types/static-1.2868",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8543",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11050",
  "immutable-less": "/immutable-less/static-1.5160",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18506",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21099",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8459",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4424",
  "growth-data-modal": "/growth-data-modal/static-1.6177",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3042",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5654",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8172",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29614",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1262",
  "highlight.js": "/highlight.js/static-1.92",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13649",
  "content-media-compositions": "/content-media-compositions/static-2.17656",
  "media-bridge-lib": "/media-bridge-lib/static-1.19689",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4935",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37332",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7308",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3879",
  "highcharts": "/highcharts/static-8.117",
  "storybook-react": "/storybook-react/static-1.46",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16722",
  "browser-eslint": "/browser-eslint/static-2.57",
  "ContentData": "/ContentData/static-1.69626",
  "layout-data-lib": "/layout-data-lib/static-1.10575",
  "academy-common-lib": "/academy-common-lib/static-1.15571",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3227",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3546",
  "whisper-core-api": "/whisper-core-api/static-1.7685",
  "flux-actions": "/flux-actions/static-1.383",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14913",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6133",
  "redux-observable": "/redux-observable/static-1.81",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4116",
  "oauth-service-types": "/oauth-service-types/static-1.4645",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8638",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1710",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2884",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3070",
  "user-context-client": "/user-context-client/static-1.5018",
  "js-cookie": "/js-cookie/static-1.18",
  "advanced-menus-core": "/advanced-menus-core/static-1.15868",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12608",
  "ExportDialog": "/ExportDialog/static-6.10881",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35267",
  "academy-service-client": "/academy-service-client/static-1.4201",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.85",
  "SafeStorage": "/SafeStorage/static-1.4904",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7900",
  "wootric-nps": "/wootric-nps/static-1.7315",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3523",
  "settings-ui-lib": "/settings-ui-lib/static-1.13037",
  "simple-data-table": "/simple-data-table/static-1.3879",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8125",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15867",
  "simple-menus-lib": "/simple-menus-lib/static-1.17384",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.139"
}
};
